import React from 'react'
import PropTypes from 'prop-types'

const EmbedUrl = ({ url }) => {
  return <iframe className="dataContainer" src={url} title={url} />
}

EmbedUrl.propTypes = {
  url: PropTypes.string
}

export default EmbedUrl
